import React, { useRef, useState } from "react"

import classNames from "gpages/utils/classnames"
import { useScrollEvent } from "gpages/hooks/common"

import * as styles from "./nav.module.scss"
import logoImg from "@images/logo.png"
import Clickable from "../clickable"

const ITEMS = [
  {
    key: "about",
    title: "关于",
  },
  {
    key: "news",
    title: "最新",
  },
  {
    key: "business",
    title: "招商",
  },
  {
    key: "site",
    title: "主站",
    url: "https://www.gcores.com",
  },
]

const Nav = ({ location }) => {
  const [visible, setVisible] = useState(true)
  const [fixed, setFixed] = useState(false)
  useScrollEvent(() => {
    const scrollTop = window.scrollY
    const toHeaderEnd = document.querySelector("#header")?.offsetHeight + 30
    setFixed(scrollTop > toHeaderEnd)
    if (scrollTop <= toHeaderEnd / 2) {
      setVisible(true)
    } else if (scrollTop <= toHeaderEnd + 100) {
      setVisible(false)
    } else {
      setVisible(true)
    }
  })

  const handleItemClick = (e) => {
    if (!e) {
      return
    }

    const t = e.currentTarget
    const id = t.getAttribute("href")
    const elem = document.querySelector(`#${id.split("#")[1]}`)

    if (!elem) {
      return
    }

    const headerOffset = 50
    const elementPosition = elem.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })

    e.preventDefault()
  }

  return (
    <>
      <div className={styles.placeholder} />
      <nav
        className={classNames(styles.nav, {
          [styles.visible]: visible,
          [styles.fixed]: fixed,
        })}
      >
        <img src={logoImg} alt="logo" className={styles.logo} />
        <div className={styles.right}>
          {ITEMS.map(({ title, url, key }) => {
            return (
              <Clickable
                key={key}
                href={url ? undefined : `#${key}`}
                appNavTo={url}
                onClick={handleItemClick}
              >
                {title}
              </Clickable>
            )
          })}
        </div>
      </nav>
    </>
  )
}

export default Nav
